import { tv } from 'tailwind-variants';

export const styles = tv({
  slots: {
    base: 'mt-12 overflow-hidden text-[#003A70] md:mt-[60px]',
    banner: 'relative md:h-[400px]',
    content:
      'mx-auto mb-[30px] max-w-[1366px] px-3 md:mb-0 md:px-[30px] md:py-[56px] lg:absolute lg:inset-x-0 lg:top-0 lg:px-[58px] lg:pt-14',
    title:
      'mb-4 max-w-[600px] text-[22px] leading-[1.5] font-medium md:mb-8 md:max-w-[400px] md:text-[32px] md:leading-[1.2] lg:max-w-[600px] lg:text-[40px]',
    link: 'inline-flex items-center gap-1.5 text-base leading-[1.5] font-medium md:text-[22px]',
    bg: 'md:absolute md:top-0 md:left-1/2 md:z-[-1] md:h-full md:max-w-none md:-translate-x-1/2 lg:-translate-x-[54vw] xl:-translate-x-1/2',
    products:
      'relative z-1 mx-auto -mt-[91px] max-w-[1366px] pt-[49px] pr-0 pl-[14px] [--slide-size:calc(100%/1.3)] [--slide-spacing:20px] min-[1200px]:[--slide-size:calc(100%/4)] md:-mt-[168px] md:px-[30px] md:pt-[45px] md:[--slide-size:calc(100%/3)] md:[--slide-spacing:23px] lg:px-[58px]',
    arrowPrev:
      'top-3 right-12 left-auto !block bg-transparent text-[#003A70] disabled:!text-white disabled:!opacity-100 md:right-16',
    arrowNext:
      'top-3 right-2 left-auto !block bg-transparent text-[#003A70] disabled:!text-white disabled:!opacity-100 md:right-4',
    button:
      'mx-auto mt-[68px] flex h-12 w-[220px] items-center justify-center border border-[#003A70] bg-[#003A70] text-base leading-[1.2] font-medium tracking-[-0.4px] text-white md:mt-[61px] md:w-[300px] lg:hover:bg-white/70 lg:hover:text-[#003A70]'
  }
});
